<!-- 合同延期申请 -->
<template>
  <div>
    <el-descriptions size="medium" border :column="2">
      <el-descriptions-item>
        <template slot="label">公司名称</template>
        {{ autoInput.corporate_name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">旗舰店</template>
        {{ autoInput.shop_name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">品牌名</template>
        {{ autoInput.brand_name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">合同到期时间</template>
        {{ autoInput.due_time.split(" ")[0] }}
      </el-descriptions-item>
    </el-descriptions>
    <!-- <div>
      <el-radio-group v-model="inputType">
        <el-radio label="days">按天数</el-radio>
        <el-radio label="date">按日期</el-radio>
      </el-radio-group>
    </div> -->
    <div class="defer_operate">
      <div class="days_select">
        <el-input-number
          v-model="formData.deferred_days"
          controls-position="right"
          :min="1"
          :max="14"
          @change="dayChange"
          placeholder="设置延期天数"
        >
        </el-input-number>
        <span class="warning_info" v-if="formData.deferred_days == 14">
          请注意，单次最多可申请延期14天
        </span>
      </div>
      <div class="defer_date padding-20">
        <p class="title mb-5">延期至</p>
        <p class="predict">{{ formData.deferred_time || "----" }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    autoInput: {
      type: Object,
    },
  },
  data() {
    return {
      formData: {
        deferred_days: undefined,
        deferred_time: "",
      },
      inputType: "days", // 设置类型
    };
  },
  created() {
    this.formData = { ...this.formData, ...this.autoInput };
  },
  methods: {
    dayChange() {
      if (this.formData.deferred_days === 0) {
        return;
      }
      // 未到期时，再到期时间的基础上延期
      // 否则，在当前日期上延期
      if (this.formData.due_day > 0) {
        this.formData.deferred_time = moment(this.formData.due_time)
          .add(this.formData.deferred_days, "days")
          .format("YYYY-MM-DD");
      } else {
        this.formData.deferred_time = moment()
          .add(this.formData.deferred_days, "days")
          .format("YYYY-MM-DD");
      }

      this.$emit("deferApplyParams", this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
.defer_operate {
  display: flex;
  align-items: center;
  margin-top: 5px;
  .days_select {
    position: relative;
    .warning_info {
      position: absolute;
      bottom: -40px;
      left: 0;
      right: -5px;
      color: rgb(250, 43, 43);
    }
  }
  .defer_date {
    flex: 1;
    text-align: center;
    border: 2px dashed #e6e6e6;
    margin-left: 50px;
    .title {
      font-size: 16px;
      color: #b1b0b0;
    }
    .predict {
      font-size: 14px;
    }
  }
}
</style>
